import React, { useEffect, useState } from 'react';
import { ChevronDown, Info } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Card } from '../../../components/ui/card';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '../../../components/ui/collapsible';

const STORAGE_KEY = 'adminDuplicatesInfoOpen';

/** Объяснение для админа простыми словами: что такое дубль и что делает склейка. */
export function InfoCard() {
  const [open, setOpen] = useState<boolean>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved === null ? true : saved === '1';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, open ? '1' : '0');
    } catch {
      /* без localStorage просто не запоминаем */
    }
  }, [open]);

  const heading = 'mb-1 font-semibold text-text';

  return (
    <Card className="overflow-hidden">
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger asChild>
          <button
            type="button"
            className="flex w-full items-center gap-3 p-[18px] text-left outline-none hover:bg-surface-alt focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
          >
            <div className="grid size-9 shrink-0 place-items-center rounded-xl bg-muted text-text-2">
              <Info className="size-5" aria-hidden />
            </div>
            <div className="flex-1">
              <p className="font-display font-bold text-text">Как работают дубли и склейка</p>
              <p className="text-xs text-text-2">Прочитайте один раз перед первой склейкой</p>
            </div>
            <ChevronDown className={cn('size-5 text-text-2 transition-transform', open && 'rotate-180')} aria-hidden />
          </button>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="grid gap-5 px-[18px] pb-[18px] text-sm leading-relaxed text-text md:grid-cols-2">
            <div>
              <p className={heading}>Что такое дубль</p>
              <p>
                Человек вошёл через Telegram и получил <b>новый пустой аккаунт</b>, хотя у него уже
                был старый (через email, Google или Apple) — часто с премиумом и прогрессом. Telegram
                к старому аккаунту не был привязан, поэтому система не узнала человека. Новый аккаунт
                — <b>дубль</b>, старый — <b>основной</b>.
              </p>
            </div>
            <div>
              <p className={heading}>Что делает склейка</p>
              <p>
                Переносит вход через Telegram и номер телефона с дубля на основной аккаунт. После
                этого человек, входя через Telegram, попадает в свой старый аккаунт. Дубль{' '}
                <b>не удаляется</b>: он помечается «склеен» и больше не может входить. Прогресс
                дубля (решённые билеты, попытки) <b>не переносится</b> — остаётся в архиве на дубле.
                Кнопкой склейку не отменить.
              </p>
            </div>
            <div>
              <p className={heading}>Почему оплаты блокируют склейку</p>
              <p>
                Если на дубле были оплаты или подписка, деньги и премиум привязаны к нему, а
                склейка их не переносит. Такие случаи решаем вручную: вернуть деньги или продлить
                премиум на основном аккаунте — и только потом разбираться с дублем.
              </p>
            </div>
            <div>
              <p className={heading}>Откуда «Возможные дубли»</p>
              <p>
                Когда на том же телефоне раньше был вход в один аккаунт, а потом через Telegram
                создан другой, система запоминает эту пару. Это <b>подсказка, а не факт</b>:
                телефоном могли пользоваться двое (например, брат и сестра). Сверьте данные и решите
                сами — «Склеить…» или «Не дубль».
              </p>
            </div>
          </div>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
}
